var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.24567 10.9711C1.24567 12.849 2.71447 14.3713 4.52633 14.3713C5.91731 14.3713 7.10611 13.4741 7.58334 12.2075H10.4166C10.8938 13.4741 12.0826 14.3713 13.4736 14.3713C15.2854 14.3713 16.7543 12.849 16.7543 10.9711C16.7959 10.2643 16.5121 7.75046 15.58 5.66799C14.9343 4.22505 13.3889 3.62921 11.8542 3.62921H6.14579C4.61113 3.62921 3.06568 4.22505 2.4199 5.66799C1.48788 7.75046 1.20405 10.2643 1.24567 10.9711Z",
    stroke: "black",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.782 9.91305C11.592 9.91305 11.485 9.80614 11.485 9.61608C11.485 9.42601 11.592 9.31909 11.782 9.31909",
    stroke: "black",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7837 9.91305C11.9738 9.91305 12.0807 9.80614 12.0807 9.61608C12.0807 9.42601 11.9738 9.31909 11.7837 9.31909",
    stroke: "black",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5735 7.84103C13.3835 7.84103 13.2766 7.73412 13.2766 7.54405C13.2766 7.35399 13.3835 7.24707 13.5735 7.24707",
    stroke: "black",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5752 7.84103C13.7653 7.84103 13.8722 7.73412 13.8722 7.54405C13.8722 7.35399 13.7653 7.24707 13.5752 7.24707",
    stroke: "black",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.43445 7.32239V9.70832",
    stroke: "black",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.24084 8.51538H6.62677",
    stroke: "black",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGame);
export default __webpack_public_path__ + "static/media/game.3d668c9ca6da46df2447e774a7fc723e.svg";
export { ForwardRef as ReactComponent };